import React from 'react'
import { Round } from "../../types"

interface TeeHeaderProps {
  round: Round
}

export default function TeeHeader({ round }: TeeHeaderProps) {
  return (
    <div className="tee-header">
      {round.course.shortLabel} {round.tee.name} Tees
    </div>
  )
}
